export const configuration = {
    debug: {
        enable: false, //main switch
        useMockDeployments: true,
        useMockDaemonInfo: true,
    },
};
export const UI_FET_DECIMALS = 4; //for a more visual appearance only. In fact, FET has 18 decimals
